<div class="row" *ngIf="records">
  <div class="col-sm-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title font-medium-1 display-inline">
          {{ routeTitle }}
        </h4>
        <button
          *ngIf="fileXlsxButton"
          class="btn btn-raised btn-info pull-right mx-1"
          [disabled]="isUploading"
          matTooltip="{{ uploadDocumentText }}"
          (click)="fileInput.click()"
        >
          <span>{{ uploadDocumentText }}</span>
        </button>
        <input
          type="file"
          #fileInput
          placeholder="{{ uploadDocumentText }}"
          accept=".xlsx"
          (change)="uploadDocument($event)"
          style="display: none"
        />
        <a
          *ngIf="!hideButton"
          (click)="addRoute()"
          class="btn btn-raised btn-primary pull-right"
          >{{ addBtnText }}</a
        >
        <a
          *ngIf="canCopy"
          class="btn btn-raised btn-amber pull-right mx-1"
          (click)="onCopySettings()"
          >Copiar configuración</a
        >
        <button
          type="button"
          *ngIf="isDownloadable"
          class="btn btn-raised btn-purple pull-right mx-1"
          (click)="onDownload()"
          matTooltip="Descargar .CSV"
        >
          <span class="fa fa-download"></span>
        </button>
      </div>
      <div class="col-sm-12" *ngIf="filters">
        <div class="row">
          <div class="col-sm-2" *ngFor="let filter of filters">
            <fieldset class="form-group">
              <select
                class="form-control"
                *ngIf="filter.type == 'select'; else inputFilter"
              >
                <option value="">{{ filter.title }}</option>
                <option
                  *ngFor="let option of filter.options"
                  value="{{ option.value }}"
                >
                  {{ option.label }}
                </option>
              </select>
              <ng-template #inputFilter>
                <input
                  type="text"
                  class="form-control"
                  placeholder="{{ filter.title }}"
                />
              </ng-template>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="card-body px-0">
        <div class="card-block">
          <div class="table-responsive">
            <table class="table text-center table-striped">
              <thead>
                <tr>
                  <th
                    class="text-bold-400 font-small-3"
                    *ngFor="let map of columnMaps"
                    [class.fixed-width-cell]="map.width"
                    [style.width]="map.width"
                    [style.maxWidth]="map.width"
                  >
                    <a>
                      {{ map.header }}
                    </a>
                  </th>
                  <th class="text-bold-400 font-small-2">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let record of records; trackBy: trackByFn">
                  <td
                    *ngFor="let map of columnMaps"
                    class="text-bold-300 font-small-2"
                    [class.fixed-width-cell]="map.width"
                    [style.width]="map.width"
                    [style.maxWidth]="map.width"
                    [matTooltip]="map.width ? record[map.primaryKey] : null"
                    appTooltipIfTruncated
                  >
                    <span
                      *ngIf="map.primaryKey === 'status'; else simpleSpan"
                      class="{{ record[map.primaryKey] }} capitalize"
                      >{{ record[map.primaryKey] }}</span
                    >
                    <ng-template #simpleSpan>{{
                      record[map.primaryKey]
                    }}</ng-template>
                  </td>
                  <td>
                    <edit-action-button
                      *ngIf="editAction"
                      [idEntity]="record.id"
                      (editEvent)="goToEdit($event)"
                    ></edit-action-button>
                    <edit-action-button
                      *ngIf="editTaskAction"
                      [idEntity]="record.id"
                      (editEvent)="goToEditTask($event)"
                    ></edit-action-button>
                    <app-read-only-button
                      *ngIf="readOnlyAction"
                      [idEntity]="record.id"
                      (readOnlyEvent)="goToReadOnly($event)"
                    ></app-read-only-button>
                    <app-read-only-button
                      *ngIf="viewTaskAction"
                      [idEntity]="record.id"
                      (readOnlyEvent)="goToViewTask($event)"
                    ></app-read-only-button>
                    <delete-action-button
                      *ngIf="deleteAction"
                      [idEntity]="record.id"
                      (deleteEvent)="delete($event)"
                    ></delete-action-button>
                    <view-action-button
                      *ngIf="viewAction"
                      [idEntity]="record.id"
                      (viewEvent)="goToView($event)"
                    ></view-action-button>
                    <view-image-button
                      *ngIf="viewImage && record.imageUrl"
                      [url]="record.imageUrl"
                      (viewEvent)="viewImage($event)"
                    ></view-image-button>
                    <app-swap-button
                      *ngIf="swapAction"
                      [idWorkplan]="record.id"
                    ></app-swap-button>
                  </td>
                </tr>
                <tr *ngIf="!records || records.length === 0">
                  <td [colSpan]="totalColumns">Sin resultados</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row" *ngIf="records && records.length > 0 && pagination">
            <div class="col-xl-8"></div>
            <div class="col-xl-4">
              <mat-paginator
                [length]="totalRecords"
                [hidePageSize]="true"
                [pageSize]="perPage"
                [showFirstLastButtons]="true"
                (page)="onChangePage($event)"
              >
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
